import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {IVehicle, Replacement} from '../../../interface';
import {useNavigate} from 'react-router-dom';
import localesReplacement from '../../../utils/localesReplacement';
import _ from 'lodash';

const cx = classnames.bind(style);

interface IProps {
  dataList: IVehicle;
  className: string;
  replacements: Replacement;
}

export const VehicleDropdown = (props: IProps) => {
  const {dataList, className, replacements} = props;
  const navigate = useNavigate();
  const redirectHandle = (evt: React.MouseEvent) => {
    navigate('/');
    evt.stopPropagation();
  };
  const back = (evt: React.MouseEvent) => {
    navigate(-1);
    evt.stopPropagation();
  };



  return (
    <>
      <div
        className={cx('vehicle-selection', 'selected', 'hasValue', className)}
      >
        <span className={cx('back')} onClick={back}></span>
        <div className={cx('dropdown')}>
          {dataList && (
            <>
              <strong>{`${dataList['make']}  ${dataList['model']}`}</strong>
              <div>
                <span className={`${cx('selected')}`}>{`${dataList['type']}`}</span>
                { (dataList['yearFrom'] || dataList['yearTo']) && (
                  <span className={`${cx('selected')}`}>
                    {
                      `(${
                      dataList['yearFrom'] ?? ''
                    } - ${
                      dataList['yearTo'] ?? ''
                    })`
                    }
                  </span>
                )}
              </div>
            </>
          )}
        </div>
        <span role='link' className={cx('link')} onClick={redirectHandle}>
          {localesReplacement(replacements, 'Start Over')}
        </span>
      </div>
    </>
  );
};

export default VehicleDropdown;
